import { useTranslation } from "react-i18next";
import { Label, Textarea } from "@tellescope/ui";

export interface AISummaryFocusFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}

export const AISummaryFocusField = ({ value, onChange, onBlur }: AISummaryFocusFieldProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium">{t("Summary focus")}</Label>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={t("Describe what aspects of the patient's interactions to emphasize in the summary...")}
        className="min-h-[100px] resize-none"
      />
      <span className="text-xs text-muted-foreground">
        {t("This description will be used when generating new summaries.")}
      </span>
    </div>
  );
};
